import { Control } from "react-hook-form";

import { Select } from "components/form_components/Inputs";
import { useCurrentUser } from "lib/hooks/api/users/useCurrentUser";
import {
  DocumentFilters,
  documentTypes,
  isAllDocumentTypesUser,
  simplifiedDocumentTypes,
} from "../utils";

import css from "./SharedFilterGroups.module.scss";

export interface DocumentTypeFilterContentProps {
  control: Control<DocumentFilters, unknown>;
}

function DocumentTypeFilterContent({ control }: DocumentTypeFilterContentProps) {
  const { data: currentUser } = useCurrentUser();
  return (
    <div className={css.filterSection} aria-label="Document type filters">
      <Select
        mode="multiple"
        name="categories"
        control={control}
        label="Document type"
        optionFilterProp="label"
        options={isAllDocumentTypesUser(currentUser) ? documentTypes : simplifiedDocumentTypes}
        placeholder="Select document types"
      />
    </div>
  );
}

export default DocumentTypeFilterContent;
